// PAQUETES
import { useOutletContext } from 'react-router-dom';
import React from "react";
import HelmetSEO from '../../componentesEspeciales/helmetSEO';

function Devolucion(){

    const { usuario, cargandoUsuario } = useOutletContext() || {};

    return(
        <>
          <HelmetSEO
            titulo="Política de devoluciones | Zervicy"
            descripcion="Conoce cómo funcionan los reclamos, mediaciones y reembolsos de servicios dentro de Zervicy."
          />

        <div>

          <div className="container py-4">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-10">

                <div className="mb-4">
                  <h1 className="h3 fw-bold mb-1">Política de devolución</h1>
                  <p className="text-muted mb-0">
                    Aquí encontrarás información sobre nuestras políticas relacionadas con reclamos y reembolsos para servicios.
                  </p>
                </div>

                <div className="card border-0 shadow-sm">
                  <div className="card-body p-4 p-md-5">

                    <h2 className="h4 fw-bold mb-3">Política de reclamos y reembolsos (Servicios)</h2>

                    <p>
                      Esta política aplica a los servicios ofrecidos dentro de Zervicy (por ejemplo: mudanzas, paseos de mascotas, mensajería, asesorías, entre otros).
                      Los reembolsos únicamente podrán evaluarse cuando exista un incumplimiento real por parte del vendedor y el comprador abra un caso formal dentro de la plataforma.
                      Cuando se abre un reclamo, Zervicy retiene el pago hasta resolver la situación.
                    </p>

                    <h3 className="h6 fw-bold mt-4">1) ¿Cuándo puedes abrir un caso?</h3>
                    <p>
                      Puedes abrir un caso desde la app (ya sea porque el proveedor no se presentó, el servicio no se completó, o no cumplió lo acordado) mientras la reserva
                      siga activa o recién haya finalizado, <strong>hasta que quede marcada como "completada"</strong>. Si tú mismo confirmas que el servicio se prestó correctamente,
                      ya no podrás abrir un caso después de esa confirmación. Si no confirmas ni reportas nada, el sistema completa la reserva automáticamente <strong>4 horas</strong> después
                      de la hora final programada del servicio — a partir de ese momento el caso ya no se puede abrir por autoservicio desde la app. Por eso te recomendamos revisar
                      que todo esté en orden apenas termine el servicio y actuar dentro de esa ventana.
                    </p>
                    <p>
                      Si pasó esa ventana y de todas formas tienes un problema grave sin resolver, escríbenos por soporte (chat o correo) y evaluaremos el caso manualmente,
                      aunque ya no aplique el flujo automático de la app.
                    </p>

                    <h3 className="h6 fw-bold mt-4">2) Cómo abrir un caso</h3>
                    <p>
                      Para solicitar un reembolso debes abrir un caso desde la app y explicar: (a) qué ocurrió, (b) qué parte del servicio no se cumplió,
                      y (c) qué solución esperas (reembolso total, parcial o reprogramación).
                      Podremos solicitar evidencia (mensajes, fotos, videos, ubicación, comprobantes) para evaluar el caso.
                    </p>

                    <h3 className="h6 fw-bold mt-4">3) Respuesta del vendedor y mediación</h3>
                    <ul>
                      <li>Le pediremos al vendedor su versión de lo ocurrido y una posible solución.</li>
                      <li>Si no hay acuerdo entre las partes, Zervicy actuará como mediador y tomará una decisión con base en la evidencia disponible y la descripción del servicio publicado.</li>
                      <li>El tiempo de resolución varía según la complejidad del caso y la evidencia disponible; te mantendremos informado del avance.</li>
                    </ul>

                    <h3 className="h6 fw-bold mt-4">4) Tipos de reembolso</h3>
                    <ul>
                      <li><strong>Reembolso total:</strong> cuando, después de la revisión del caso, se determine que el servicio no fue prestado o existió un incumplimiento grave por parte del vendedor.</li>
                      <li><strong>Reembolso parcial:</strong> cuando el servicio fue realizado parcialmente o existieron gastos válidos y demostrables asociados al servicio.</li>
                      <li><strong>Reprogramación:</strong> cuando sea la mejor alternativa y ambas partes estén de acuerdo.</li>
                    </ul>

                    <h3 className="h6 fw-bold mt-4">5) Plazo de procesamiento del reembolso</h3>
                    <p>
                      Si el reembolso es aprobado, Zervicy lo procesa lo antes posible. El tiempo de reflejo final en tu cuenta o medio de pago no depende de nosotros,
                      sino de tu banco o entidad financiera, así que puede variar.
                    </p>

                    <h3 className="h6 fw-bold mt-4">6) Exclusiones y uso indebido</h3>
                    <p>
                      No procederán reembolsos cuando exista fraude, abuso del sistema, información falsa, o cuando el servicio haya sido prestado conforme a lo acordado
                      y no exista evidencia de incumplimiento.
                    </p>

                    <h3 className="h6 fw-bold mt-4">7) Contacto</h3>
                    <p className="mb-0">
                      Si tienes preguntas sobre esta política o necesitas ayuda para abrir un caso, contáctanos desde la sección de ayuda de la app o por correo a
                      <a className="ms-1" href="mailto:info@zervicy.com">info@zervicy.com</a>.
                    </p>

                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
        </>
    )
}

export default Devolucion;